"use client";

import Link from "next/link";
import React, { useState, useEffect } from "react";
import { Logo } from "./Logo";
import ParticleImage from "../global-ui/particle-image";
import { useMediaQuery, useWindowSize } from "usehooks-ts";
import { ModeToggle } from "./mode-toggle";
// import { LazySection } from "./lazy-section";

export const Footer = () => {
  const [mounted, setMounted] = useState(false);
  const isMobileQuery = useMediaQuery("(max-width: 768px)");

  // Only use the media query result after mounting to prevent hydration issues
  // const isMobile = mounted ? isMobileQuery : false;

  // const screen = useScreen();
  const {
    width = 0,
    height = 0
  } = useWindowSize();
  useEffect(() => {
    setMounted(true);
  }, []);

  // console.log("screen", screen);
  // console.log("windowSize", width, height);

  const links = [{
    name: "Pricing",
    href: "/pricing"
  }, {
    name: "Growth Playbooks",
    href: "/blog"
  }, {
    name: "Chat with Founder",
    href: "/contact"
  }];
  const legal = [{
    name: "Privacy (Simple)",
    href: "#"
  }, {
    name: "Terms",
    href: "#"
  }, {
    name: "Money-back Promise",
    href: "#"
  }];
  const socials = [{
    name: "Twitter",
    href: "https://twitter.com/yourusername"
  }, {
    name: "Build in Public",
    href: "https://github.com/yourusername"
  }, {
    name: "Launch Post →",
    href: "https://www.producthunt.com/posts/your-product"
  }];
  return <div className="relative dark:bg-[#09090B]" data-sentry-component="Footer" data-sentry-source-file="footer.tsx">
      <div className="relative border-t border-neutral-100 bg-gradient-to-b from-white via-white to-white px-8 pb-32 pt-20 dark:border-neutral-800 dark:from-[#09090B] dark:via-neutral-950 dark:to-[#09090B]">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between text-sm text-neutral-500 dark:text-neutral-400 sm:flex-row">
          <div>
            <div className="mb-4 mr-4 flex items-center gap-3 md:flex">
              <Logo data-sentry-element="Logo" data-sentry-source-file="footer.tsx" />
              <ModeToggle className="h-8 w-8" data-sentry-element="ModeToggle" data-sentry-source-file="footer.tsx" />
            </div>
            <div>First 100 Customers in Days.</div>
            <div className="mt-2">© 2025 Viral Launch</div>
          </div>
          <div className="mt-10 grid grid-cols-3 items-start gap-10 md:mt-0">
            <div className="mt-4 flex flex-col justify-center space-y-4">
              {links.map(link => <Link key={link.name} className="dark:text-muted-dark text-xs text-muted transition-colors hover:text-black dark:hover:text-neutral-400 sm:text-sm" href={link.href}>
                  {link.name}
                </Link>)}
            </div>
            <div className="mt-4 flex flex-col justify-center space-y-4">
              {legal.map(link => <Link key={link.name} className="dark:text-muted-dark text-xs text-muted transition-colors hover:text-black dark:hover:text-neutral-400 sm:text-sm" href={link.href}>
                  {link.name}
                </Link>)}
            </div>
            <div className="mt-4 flex flex-col justify-center space-y-4">
              {socials.map(link => <Link key={link.name} className="dark:text-muted-dark text-xs text-muted transition-colors hover:text-black dark:hover:text-neutral-400 sm:text-sm" href={link.href}>
                  {link.name}
                </Link>)}
            </div>
          </div>
        </div>
      </div>
      {/* <LazySection
        threshold={0.1}
        rootMargin="100px 0px"
        fallback={
          <div className="h-52 w-full bg-transparent md:h-96 lg:h-150" />
        }
       > */}
      <div className="relative">
        <ParticleImage imageUrl="/images/viral-launch-full-logo-white.png" maxWidth={1000} maxHeight={400} // Desktop height
      imageHeight={width > 768 ? 400 : width > 425 ? 200 : 120} mobileMaxHeight={120} // Mobile height
      containerHeight="h-52 md:h-96 lg:h-150" useImageColor={true} particleLife={() => Math.random() * 100 + 50} scatterColor={"transparent"} data-sentry-element="ParticleImage" data-sentry-source-file="footer.tsx" />
      </div>
      {/* </LazySection> */}
    </div>;
};